require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-164-displaying-week-numbers.json") })
        }
      }, "path---article-164-displaying-week-numbers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-164-displaying-week-numbers!./.cache/json/article-164-displaying-week-numbers.json
// module id = 512
// module chunks = 231608221292675